import { StatusMap } from '../../../../models/payment-links-custom';
import { CustomPaymentLinksModal } from '../custom-modal';
import { RenderIcon } from '../status';
import { Detail, Item } from './components/detail';
import { DataContainer, SectionContainer } from './styles';
import { ModalPaymentProps } from './types';

const ModalPayment = ({ show, onClose, data, positionType }: ModalPaymentProps) => {
	const LinkUsed: Item[] = [
		{
			title: 'Enlace usado',
			value: data.presession.name,
		},
	];

	let IdentifyItems: Item[] = [];
	if (data.typeError) {
		IdentifyItems = [
			{
				title: 'Estatus',
				value: StatusMap.get(data.status),
				leftIcon: RenderIcon({ status: data.status }),
			},
			{
				title: 'Detalle',
				value: data.typeError,
			},
		];
	} else {
		IdentifyItems = [
			{
				title: 'Estatus',
				value: StatusMap.get(data.status),
				leftIcon: RenderIcon({ status: data.status }),
			},
		];
	}

	const IdentifyItems2: Item[] = [
		{
			title: 'Fecha de creación',
			value: data.createdatDate,
		},
		{
			title: 'Hora',
			value: data.createdatTime,
		},
		{
			title: 'Monto',
			value: data.amount + ' CLP',
		},
	];

	const IdentifyItems3: Item[] = [
		{
			title: 'RUT Pagador',
			value: data.rut,
		},
		{
			title: 'Banco',
			value: data.bankName,
		},
		{
			title: 'Tipo de cuenta',
			value: data.accountType,
		},
		{
			title: 'Número de cuenta',
			value: data.account,
		},
	];

	const PersonalizedInfo: Item[] = [
		{
			title: 'RUT',
			value: data.fieldResponse?.find((item) => item.key === 'rut')?.value,
		},
		{
			title: 'Nombre y apellido',
			value: data.fieldResponse?.find((item) => item.key === 'names' || item.key === 'name')?.value,
		},
		{
			title: 'Correo electronico',
			value: data.fieldResponse?.find((item) => item.key === 'email')?.value,
		},
	];

	const backgroundPersonalizedInfo = '#F6F5FF';

	const OtherDats: Item[] = [
		{
			title: 'Payment ID',
			value: data.paymentId,
		},
		{
			title: 'Transfer ID',
			value: data.transferId,
		},
		{
			title: 'Fecha creación',
			value: data.createdatDate + ' ' + data.createdatTime,
		},
		{
			title: 'Fecha expiración',
			value: data.expireDate + ' ' + data.expireTime,
		},
	];

	return (
		<CustomPaymentLinksModal
			show={show}
			onClose={onClose}
			title={data.rut}
			subTitle="Pagos recibidos"
			type="small"
			allowCloseModal
			positionType={positionType || 'top-right'}
		>
			<DataContainer>
				<SectionContainer>
					<Detail items={LinkUsed} />
				</SectionContainer>
				<SectionContainer>
					<Detail title="Identificación" items={IdentifyItems} />
					<Detail items={IdentifyItems2} />
					<Detail items={IdentifyItems3} />
				</SectionContainer>
				<SectionContainer>
					<Detail
						title="Información personalizada"
						items={PersonalizedInfo}
						backgroundColor={backgroundPersonalizedInfo}
					/>
				</SectionContainer>
				<SectionContainer>
					<Detail title="Otros datos" items={OtherDats} />
				</SectionContainer>
			</DataContainer>
		</CustomPaymentLinksModal>
	);
};

export { ModalPayment };
